import React, { useState, useContext, useEffect } from 'react';
import BasicContext from '../BasicContext';
import { List, Accordion, SwipeAction, Icon, Toast, Button } from 'antd-mobile';
import copy from 'copy-to-clipboard';

import * as Api from "../../../api/usms";
import { Purpose, } from '../utils/const';
// import { keyHasPermission, AclKeys } from '../utils/permissions';
import { renderCountryCNameByBrevityCode, renderChannelCNameByChannelId } from '../utils/common';
// import Permission from '../components/Permission';

import { Loading, Empty, TitleDescriptions } from '../components';
import Filters from './Filters';
import '../index.css';

const defaultFilters = {
  Page: 0,
  NumberPerPage: 10,
};

export default function ChannelView(props) {

  const context = useContext(BasicContext);
  // const customerList = context.customers || [];
  const countryList = context.countryList || [];
  const channelList = context.channels || [];
  // const permissions = context.permissions || [];

  const [list, setList] = useState();
  const [filteredList, setFilteredList] = useState();
  const [totalCount, setTotalCount] = useState(0);
  const [accounthannelList, setAccountChannelList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [channelLoading, setChannelLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [filter, setFilters] = useState(defaultFilters);
  const [activeKey, setActiveKey] = useState("filter");

  const getList = (params) => {
    const data = {
      ...params,
      Limit: 9999
    }

    setLoading(true);
    Api.DescribeChannelControlWithRisk(data).then(res => {
      const currentList = res.Data || [];
      setList(currentList);
      searchList(filter, currentList);
      setLoading(false);
    }).catch(e => {
      setLoading(false);
      setErrorMessage(e.message || "获取数据失败")
    });
  }

  const getItemChannel = (item) => {
    try {
      const weights = JSON.parse(item.ChannelWeight || '[]');
      return weights;
    } catch {
      return [];
    }
  }

  const getChannelInfo = (item, type) => {
    const weights = getItemChannel(item);
    const weight = weights.filter((item) => item.Type === type);
    if (weight.length) {
      return `${weight[0].Channel}/${weight[0].Weight}`;
    } else {
      return '';
    }
  }

  const filterList = (list, currentFilter = filter) => {
    return list.slice(currentFilter.Page * currentFilter.NumberPerPage, currentFilter.Page * currentFilter.NumberPerPage + currentFilter.NumberPerPage);
  };

  const searchList = (values, currentList = list) => {
    if (values) {
      const searchedList = (currentList || []).filter(item => {
        if (values.AccountId && !(item.OrganizationId === values.AccountId || item.AccountId === values.AccountId)) {
          return false;
        }
        if (values.BrevityCode && item.BrevityCode !== values.BrevityCode) {
          return false;
        }
        if (values.ProtoType && values.ProtoType.length && item.ProtoType !== values.ProtoType) {
          return false;
        }
        if (values.Purpose && values.Purpose.length && item.Purpose !== values.Purpose) {
          return false;
        }
        if (values.SmppAccount && item.SmppAccount !== values.SmppAccount) {
          return false;
        }
        if (values.mainChannel || values.prepareChannel) {
          const weights = getItemChannel(item);
          const main = weights.filter(weight => weight.Type === 0);
          const prepare = weights.filter(weight => weight.Type === 1);
          if (values.mainChannel && main.filter((x) => values.mainChannel === x.Channel).length === 0) {
            return false;
          }
          if (values.prepareChannel && prepare.filter((x) => values.prepareChannel === x.Channel).length === 0) {
            return false;
          }
        }

        return true;
      });

      const currentFilter = {
        ...values,
      }

      setTotalCount(searchedList.length);
      setFilters(currentFilter);
      setFilteredList(filterList(searchedList, currentFilter));
    }
  }

  const onFilter = (values) => {
    setActiveKey(); // 收起查询条件
    searchList({ ...values, Page: 0, NumberPerPage: filter.NumberPerPage });
  }

  const handlePreviousPage = () => {
    const currentFilter = {
      ...filter,
      Page: filter.Page - 1
    } 
    searchList(currentFilter);
  }

  const handleNextPage = () => {
    const currentFilter = {
      ...filter,
      Page: filter.Page + 1
    } 
    searchList(currentFilter);
  }

  // const gotoDetail = (item) => {
  //   const CompanyId = getCompanyIdByOrgId(customerList, item.OrganizationId);
  //   window.location.href = `/usms/senddetail?id=${item.SessionId}&sendtime=${item.SendTime}&companyId=${CompanyId}`;
  // };

  const ChannelRow = ({ item }) => {
    return (
      <SwipeAction
        autoClose
        right={[
          {
            text: '一键复制',
            onPress: () => {
              copy(item.ChannelId);
              Toast.success('已复制到剪切板', 3);
            },
            style: { backgroundColor: '#108ee9', color: 'white' },
          },
        ]}
      >
        <List.Item
          extra={<span style={{ fontSize: '12px' }}>左滑操作</span>}
          wrap
          arrow="horizontal"
          style={{ background: 'aliceblue' }}
          onClick={() => { }}
        >
          <div style={{ fontSize: '14px', width: '100%', }}>
            {renderChannelCNameByChannelId(item.ChannelId, channelList)}
          </div>
        </List.Item>
      </SwipeAction>
    )
  }

  const handleItemOpen = (key, record) => {
    if (record && record.Id >= 0) {
      if (key >= 0) {
        setChannelLoading(true);
        Api.GetDispatchConfigDetail({
          Id: +record.Id,
        }).then((res) => {
          if (res.RetCode === 0) {
            setAccountChannelList(res.Data && res.Data.List && res.Data.List.length ? res.Data.List : []);
          }
          setChannelLoading(false);
        });
      } else {
        setAccountChannelList([]);
      }
    }
  }

  useEffect(() => {
    getList(defaultFilters);
  }, []);

  return (
    <div className="container">
      {/* <Permission> */}
      <Accordion activeKey={activeKey} onChange={key => setActiveKey(key)} className="mb-10">
        <Accordion.Panel header="短信通道配置查询" key="filter">
          <Filters defaultFilters={defaultFilters} onFilter={onFilter} />
        </Accordion.Panel>
      </Accordion>
      <Loading loading={loading} error={errorMessage}>
        {filteredList && (filteredList.length > 0 ?
          <Accordion accordion className='custom' onChange={key => handleItemOpen(key, filteredList[key])}>
            {filteredList.map((item, index) => {
              const weights = getChannelInfo(item, 0); // 主通道

              const descriptions = [
                item.CompanyId,
                item.CompanyEmail,
                renderCountryCNameByBrevityCode(item.BrevityCode, countryList),
                Purpose[item.Purpose],
                item.ProtoType,
                item.SmppAccount ? `SMPP账号: ${item.SmppAccount}` : '',
                weights ? `主通道/权重: ${weights}` : '',
              ].filter(item => item);

              return (
                <Accordion.Panel key={index} header={(
                  <List.Item
                    wrap
                    multipleLine
                    arrow="empty"
                    // onClick={() => gotoDetail(item)}
                    key={index}
                  >
                    <TitleDescriptions
                      title={`(${item.AccountId || item.OrganizationId || 0})${item.AccountName || item.OrganizationName || '-'}`}
                      descriptions={descriptions}
                    />
                  </List.Item>
                )}>
                  <Loading loading={channelLoading} style={{ width: '100%' }}>
                    <List>
                      {accounthannelList.map((item, index) => {
                        return <ChannelRow item={item} key={index} />
                      })}
                      {accounthannelList.length === 0 ? (
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '12px', fontSize: '12px', color: 'red' }}>
                          <Icon type='cross-circle' />
                          <span>当前项目下没有通道调度信息</span>
                        </div>
                      ) : null}
                    </List>
                  </Loading>
                </Accordion.Panel>
              )
            })}
          </Accordion>
          : <Empty />)}
        <div style={{ width: '100%', justifyContent: 'flex-end', marginTop: '8px', display: 'flex', alignItems: 'center' }}>
          <div className="mr-10" style={{ display: 'inline-block' }}>共{totalCount}条</div> 
          <Button className="mr-10" inline size='small' disabled={filter.Page === 0} onClick={() => handlePreviousPage()}>{"<<上一页"}</Button>
          <Button inline size='small' disabled={filteredList && filteredList.length < filter.NumberPerPage} onClick={() => handleNextPage()}>{"下一页>>"}</Button>
        </div>
      </Loading>
      {/* </Permission> */}
    </div>
  )
}